import Layout from '@/components/Layout';
import Meta from '@/components/Meta';

import ContactBlock from '@/_content/blocks/contact/ContactBlock.mdx';
import ContactForm from '@/components/contact-form/ContactForm';
import TermsButton from '@/components/common/TermsButton';

import useConfig from '@/hooks/useConfig';

export default function ContactPage() {
  const { t } = useConfig();

  return (
    <>
      <Meta title={t('contact.meta.title')} description={t('contact.meta.description')} />

      <Layout>
        <div className="columns">
          <div className="column">
            <ContactBlock />
            <TermsButton withFillerText={true} />
          </div>
          <div className="column">
            <ContactForm />
          </div>
        </div>
      </Layout>
    </>
  );
}
